import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { Clock, HelpCircle } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export const OverdueInspections: React.FC<{ data: any }> = ({ data }) => {
  const navigate = useNavigate();
  const handleViewDetails = (row: any) => {
    const status = row.status?.toLowerCase();

    // Determine the route based on status
    let routePrefix = "";

    switch (status) {
      case "created":
      case "overdue":
        routePrefix = "pending";
        break;
      case "assigned":
      case "accepted":
      case "in-progress":
      case "in progress":
        routePrefix = "assigned";
        break;
      case "completed":
        routePrefix = "completed";
        break;
      case "canceled":
      case "cancelled":
      case "approved":
        routePrefix = "history";
        break;
      default:
        // Default to pending for unknown statuses
        routePrefix = "pending";
    }

    navigate(
      `/ax/service-order/landing/${routePrefix}/view/Asset/${row.jobCardId}`
    );
  };
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <div>
            <CardTitle className="text-lg flex items-center gap-2">
              <Clock className="h-5 w-5" />
              Overdue Inspections
            </CardTitle>
          </div>
          <div className="mt-1">
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="max-w-xs">
                  Mandatory inspections for assets in this network that have not
                  been completed by their scheduled due date
                </p>
              </TooltipContent>
            </Tooltip>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 mt-3">
          {data?.overdueInspections?.length ? (
            data.overdueInspections.map((inspection, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-3 bg-gray-50 rounded"
              >
                <div>
                  <p className="font-medium">{inspection.assetName}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Badge
                      variant={
                        inspection.priority === "high"
                          ? "destructive"
                          : inspection.priority === "medium"
                          ? "secondary"
                          : "default"
                      }
                    >
                      {inspection.priority}
                    </Badge>
                    <span className="text-xs text-red-600">
                      Overdue {inspection.daysOverdue}
                    </span>
                  </div>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handleViewDetails(inspection)}
                >
                  View
                </Button>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 italic text-center py-4">
              No overdue inspections found.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
